import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import { IoIosAddCircleOutline, IoIosRemoveCircleOutline } from 'react-icons/io';

const NewFaqSection = ({ FaqTableData, heading, mobileView,description, }) => {
   const [viewAll, setViewAll] = useState(false);
   const [showAns, setShowAns] = useState({ key: "", status: false });
   const [showAtRender, setShowAtRender] = useState(true);
   const [isMobileView, setIsMobileView] = useState(false);

   useEffect(() => {
      const handleResize = () => {
         setIsMobileView(window.innerWidth < 600);
      };

      handleResize(); 
      window.addEventListener("resize", handleResize); 

      return () => window.removeEventListener("resize", handleResize); 
   }, []);

   useEffect(() => {
      const timer = setTimeout(() => {
         setShowAtRender(false);
      }, 2000);

      return () => clearTimeout(timer);
   }, []);

   const handleScroll = (e) => {
      e.preventDefault();
      const href = e.currentTarget.href;
      const targetId = href.replace(/.*\#/, "");
      const elem = document.getElementById(targetId);
      elem?.scrollIntoView({
         behavior: "smooth",
      });
   };

   const initialFAQsCount = 5;
   const displayedFAQs = viewAll ? FaqTableData : FaqTableData.slice(0, initialFAQsCount);

   return (
      <div style={{maxWidth:"1850px", margin:"auto",}}>
      <div style={{ margin: "5rem 2rem", display: "flex", flexDirection: "column", alignItems: "center" }}>
         <div style={{ width: "fit-content", margin: "auto" }}>
            <h3 id="preview-faqs-headline" style={{ fontFamily: "GilroyBold", fontSize: "2.8rem", textAlign: 'center', margin: '1rem 0', }}> {heading || "Frequently asked questions"}</h3>
            <p style={{ color: ' #475467', fontFamily: 'GilroyRegular', textAlign: 'center', fontSize: "1.8rem", margin: "1.5rem 0" }}>{description || "All you need to know about the product and seamless billing"}</p>
         </div>
         <div style={{ width: isMobileView ? "100%" : "60%" }}>
            {displayedFAQs?.map((ele, idx) => {
               return (
                  <div id={`preview-faq-${idx + 1}`} key={ele?.id ?? idx}>
                     <div style={{ padding: "2rem 1rem 1rem 1rem", borderBottom: "1px solid #ececec", backgroundColor: "white" }}>
                        <div
                           style={{
                              display: "flex",
                              justifyContent: "space-between",
                              gap: "5rem",
                              cursor: "pointer",
                              color: "#101828",
                              font: "normal normal 500 1.8rem/2.2rem",
                           }}
                           onClick={() =>
                              setShowAns({
                                 key: ele?.id,
                                 status: showAns?.key === ele?.id ? !showAns?.status : true,
                              })
                           }
                        >
                           <p
                              id={`preview-faq-${idx + 1}-question`}
                              style={{
                                 color: "#626060",
                                 marginBottom: "0",
                                 fontFamily: "GilroyMedium"
                              }}
                           >
                              {ele?.para}
                           </p>
                           <span style={{ color: "#2a6ab4", width: "24px", height: "26px", padding: "2px" }}>
                              {showAns?.key === ele?.id && showAns?.status ? (
                                 <IoIosRemoveCircleOutline />
                              ) : (
                                 <IoIosAddCircleOutline />
                              )}
                           </span>
                        </div>
                        <div
                           id={`preview-faq-${idx + 1}-answer`}
                           style={
                              showAns?.key === ele?.id && showAns?.status
                                 ? {
                                    color: "#475467",
                                    maxHeight: "40rem",
                                    transition: "all 0.3s",
                                    paddingTop: "1rem",
                                    marginRight: "3rem",
                                    textAlign: "start",
                                    fontFamily: "GilroyRegular"
                                 }
                                 : {
                                    color: "#475467",
                                    maxHeight: "0rem",
                                    transition: "all 0.3s",
                                    marginRight: "3rem",
                                    display: "none",
                                    textAlign: "start"
                                 }
                           }
                        >
                           {(showAns?.key === ele?.id && showAns?.status) || showAtRender ? ele?.des : ""}
                        </div>
                     </div>
                  </div>
               );
            })}
         </div>
         <Link
            href="#preview-faqs-headline"
            onClick={(e) => handleScroll(e)}
            style={{ textDecoration: "none" }}
         >
            <p
               style={{
                  color: "#2a6ab4",
                  cursor: "pointer",
                  marginTop: "3rem",
                  // font: "normal normal 500 1.6rem/2rem Inter",
               }}
               onClick={() => setViewAll(!viewAll)}
            >
               {viewAll ? "View Less" : "View More"}
            </p>
         </Link>
      </div>
      </div>
   );
};

export default NewFaqSection;